//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { InstagramTaggedUser } from '@bvengineering/universal-scheduling-gateway-service-types';

import Cuid from '@models/Cuid';
import { ISpatialTagCoordinates } from '@models/ISpatialTagCoordinates';
import InstagramUsername from '@models/InstagramUsername';

export interface ITaggedUser {
  cuid?: Cuid;
  username: InstagramUsername;
  coordinates: ISpatialTagCoordinates;
  mediaIndex: number;
}

export function toInstagramTaggedUser(user: ITaggedUser): InstagramTaggedUser {
  return {
    instagramUsername: user.username,
    X: user.coordinates.x,
    Y: user.coordinates.y,
    mediaIndex: user.mediaIndex,
  };
}

export function fromInstagramTaggedUser(
  user: InstagramTaggedUser,
): ITaggedUser {
  return {
    username: InstagramUsername(user.instagramUsername),
    coordinates: {
      x: user.X,
      y: user.Y,
    },
    mediaIndex: user.mediaIndex,
  };
}

export function mapInstagramUserWithCuidToTaggedUser(
  cuid: Cuid,
  user: InstagramTaggedUser,
): ITaggedUser {
  return {
    cuid: cuid,
    coordinates: {
      x: user.X,
      y: user.Y,
    },
    mediaIndex: user.mediaIndex,
    username: InstagramUsername(user.instagramUsername),
  };
}
